import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../footer/footer.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-minimal-shell',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, ToastModule],
  templateUrl: './minimal-shell.component.html',
  providers: [MessageService],
})
export class MinimalShellComponent { }
